export const SET_THEME = 'communityTheme/SET_THEME';